<template>
  <settings-modal class="payment-force-postponed-auto-swift-modal">
    <template slot="heading">Force out of working hours</template>

    <template>
      <date-picker
        v-model="form.valueDate"
        class="t-value-date-field"
        label="Value date"
        prepend-icon="event"
        persistent-hint
        :allowed-dates="filterDate"
        :error-messages="getValidationErrorMessage('valueDate')"
      />

      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        class="t-settle-button"
        color="primary"
        medium
        flat
        :disabled="!isFormFilled || loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-button"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Utils
  import { formatDate } from '@/utils/Date'
  import { isWorkday, getNextWorkday } from '@/utils/Transactions'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Mixins
  import form from '@/mixins/form'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import DatePicker from '@/components/ui/DatePicker'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'PaymentForcePostponedAutoSwiftModal',
    components: {
      SettingsModal,
      DatePicker,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        form: { valueDate: null },
        requiredFields: ['valueDate'],
        forcePostponedAutoSwiftApiRequest: new ApiRequest(PaymentApi.forcePostponedAutoSwiftByAccountant)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      allowedValueDates () {
        const valueDates = []

        while (valueDates.length !== 3) {
          if (valueDates.length === 0) {
            valueDates.push(isWorkday(new Date()) ? formatDate(new Date()) : getNextWorkday(new Date()))
          } else {
            valueDates.push(getNextWorkday(new Date(valueDates[valueDates.length - 1])))
          }
        }

        return valueDates
      },
      paymentId () {
        return this.modal.data.paymentId
      },
      loading () {
        return this.forcePostponedAutoSwiftApiRequest.loading
      },
      error () {
        return this.forcePostponedAutoSwiftApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.forcePostponedAutoSwiftApiRequest.execute(this.paymentId, this.parsedFormInput['valueDate'])
          .then(() => {
            this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
            this.closeModal()

            setTimeout(() => {
              this.showModal({
                name: 'SuccessFlashModal',
                data: { message: 'Payment has been successfully updated' }
              })
            }, 100)
          })
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      filterDate (date) {
        return this.allowedValueDates.includes(date)
      }
    }
  }
</script>
